// ── FAQ accordion ────────────────────────────────────────────
document.addEventListener('toggle', function (e) {
  var item = e.target;
  if (!item.classList || !item.classList.contains('faq-item') || !item.open) return;
  var root = item.closest('.timestill');
  if (!root) return;
  root.querySelectorAll('.faq-item').forEach(function (other) {
    if (other !== item) other.open = false;
  });
}, true);

// ── Mobile nav toggle ────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  if (window.__timestillNavInit) return;
  window.__timestillNavInit = true;

  var toggle = document.querySelector('[data-timestill-nav-toggle]');
  var links  = document.querySelector('[data-timestill-nav-links]');
  if (!toggle || !links) return;

  // Overlay — NO transition, instant hide
  var overlay = document.createElement('div');
  overlay.id = 'timestill-nav-overlay';
  overlay.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:9',
    'display:none',
    'opacity:0',
    'pointer-events:none'
  ].join(';');
  document.body.appendChild(overlay);

  function openMenu() {
    overlay.style.display = 'block';
    overlay.style.opacity = '1';
    overlay.style.pointerEvents = 'auto';
    links.classList.add('open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.classList.add('is-open');
  }

  function closeMenu() {
    // Instantly hide overlay — no fade, no delay
    overlay.style.opacity = '0';
    overlay.style.display = 'none';
    overlay.style.pointerEvents = 'none';
    links.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.classList.remove('is-open');
  }

  toggle.addEventListener('click', function () {
    links.classList.contains('open') ? closeMenu() : openMenu();
  });

  overlay.addEventListener('click', closeMenu);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  links.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', closeMenu);
  });
});